import React, { useCallback } from "react";
import { IPairingLogicModifier, ICrewLogicModifier } from "@vmosolutions/oc-interfaces";
import { Grid, Tooltip, Chip } from "@mui/material";
import { invertHexColor } from "src/pages/FlightTimeline/TimelineUtils";

export type ILogicModifierTypes = IPairingLogicModifier | ICrewLogicModifier;
export interface ILMGroupChipProps {
  logicModifiers: ILogicModifierTypes[];
  handleDelete: (index: number) => any;
  handleLogicModifierClick: (logicModifier: ILogicModifierTypes) => any;
  activeSelection?: ILogicModifierTypes;
}

interface IGroupChipProps extends ILMGroupChipProps {
  logicModifierInRange: (value: ILogicModifierTypes) => boolean;
}

export const LMGroupChip = (props: IGroupChipProps): JSX.Element => {
  const { logicModifiers, activeSelection, handleDelete, handleLogicModifierClick, logicModifierInRange } = props;

  const groupId = "LMGroup";
  return (
    <Grid container key={groupId} id={groupId} direction="row" spacing={0}>
      <Tooltip title={`Group Event Count: ${logicModifiers.length}`} enterDelay={1000} placement="top">
        <Grid item>
          {logicModifiers.map((logicModifier: ILogicModifierTypes, index: number) => {
            const selected = logicModifier._id === activeSelection?._id;
            return logicModifierInRange(logicModifier) ? (
              <LMChip
                selected={selected}
                key={index}
                logicModifier={logicModifier}
                handleDelete={handleDelete(index)}
                handleLogicModifierClick={handleLogicModifierClick(logicModifier)}
              />
            ) : null;
          })}
        </Grid>
      </Tooltip>
    </Grid>
  );
};

interface ILMChipProps {
  logicModifier: IPairingLogicModifier;
  handleDelete?: () => void;
  handleLogicModifierClick?: (logicModifier: IPairingLogicModifier) => any;
  selected?: boolean;
}

export const LMChip = (props: ILMChipProps): JSX.Element => {
  const { logicModifier, handleDelete, handleLogicModifierClick, selected } = props;

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
      event.stopPropagation();
      if (handleLogicModifierClick) handleLogicModifierClick(logicModifier);
    },
    [handleLogicModifierClick, logicModifier]
  );

  return (
    <Chip
      label={logicModifier.logicModifier.title}
      onDelete={handleDelete ? () => handleDelete && handleDelete() : null}
      onClick={handleClick}
      clickable={!!handleDelete || !!handleLogicModifierClick}
      size="small"
      sx={(theme) => ({
        borderRadius: "3px",
        fontWeight: 900,
        fontSize: "0.8em",
        backgroundColor: `#${logicModifier.logicModifier.color}`,
        color: invertHexColor(logicModifier.logicModifier.color),
        marginRight: "5px",
        "& svg": {
          fill: theme.palette.common.white,
          color: theme.palette.common.white,
        },
      })}
    />
  );
};
